import { createContext } from 'react';

import { OperationEntity } from 'api/types/entity/operation';

export interface OperationContextProps {
  operation: OperationEntity;
  onChangeStatus: () => void;
  onDelete: () => void;
  onEnableEdit: (onCallback: () => void) => void;
  onDisableEdit: (onCallback: () => void) => void;
}

export const OperationContext = createContext<OperationContextProps | null>(
  null
);
